import { apiFetch } from './client'
import type {
  Subscription,
  CreateSubscriptionRequest,
  UserProfile,
  SaveProfileRequest,
  NotifyResult,
} from '../types/subscription'

// ── Subscriptions ────────────────────────────────────────────────────────────

export function fetchSubscriptions(portfolioId: string): Promise<Subscription[]> {
  return apiFetch<Subscription[]>(`/api/subscriptions/${encodeURIComponent(portfolioId)}`)
}

export function createSubscription(
  portfolioId: string,
  req: CreateSubscriptionRequest,
): Promise<Subscription> {
  return apiFetch<Subscription>(`/api/subscriptions/${encodeURIComponent(portfolioId)}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(req),
  })
}

export function deleteSubscription(portfolioId: string, subscriptionId: string): Promise<void> {
  return apiFetch<void>(
    `/api/subscriptions/${encodeURIComponent(portfolioId)}/${encodeURIComponent(subscriptionId)}`,
    { method: 'DELETE' },
  )
}

// ── User profile ─────────────────────────────────────────────────────────────

export function fetchProfile(portfolioId: string): Promise<UserProfile> {
  return apiFetch<UserProfile>(`/api/profile/${encodeURIComponent(portfolioId)}`)
}

export function saveProfile(portfolioId: string, req: SaveProfileRequest): Promise<UserProfile> {
  return apiFetch<UserProfile>(`/api/profile/${encodeURIComponent(portfolioId)}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(req),
  })
}

// ── On-demand notification dispatch ──────────────────────────────────────────

export function sendTestNotification(portfolioId: string): Promise<NotifyResult> {
  return apiFetch<NotifyResult>(`/api/notify/${encodeURIComponent(portfolioId)}/test`, {
    method: 'POST',
  })
}

export function sendPortfolioReport(portfolioId: string): Promise<NotifyResult> {
  return apiFetch<NotifyResult>(`/api/notify/${encodeURIComponent(portfolioId)}/report`, {
    method: 'POST',
  })
}

export type ChatIdDetectCode = 'NO_MESSAGES' | 'INVALID_TOKEN' | 'NO_TOKEN' | 'NO_PROFILE'

export interface ChatIdDetectResult {
  chatId?: string
  error?: string
  code?: ChatIdDetectCode
}

export function detectTelegramChatId(portfolioId: string): Promise<ChatIdDetectResult> {
  return apiFetch<ChatIdDetectResult>(`/api/notify/${encodeURIComponent(portfolioId)}/chat-id`)
}

export function sendMarketReport(asset: string): Promise<NotifyResult> {
  return apiFetch<NotifyResult>(
    `/api/market/report/send?asset=${encodeURIComponent(asset)}`,
    { method: 'POST' },
  )
}
